var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPhilippines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0V16L4.68652 27.3137C7.58196 30.2091 11.582 32 16.0003 32C24.8368 32 32.0003 24.8365 32.0003 16C32.0003 7.1635 16.0003 0 16.0003 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0C11.582 0 7.58196 1.79088 4.68652 4.68625C8.61215 8.61188 10.0057 10.0055 16.0003 16H32.0003C32.0003 7.1635 24.8368 0 16.0003 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.956 15.9999L9.00198 15.0807L10.0425 13.1883L7.92066 13.5942L7.65179 11.4507L6.17379 13.0272L4.69585 11.4507L4.42691 13.5942L2.3051 13.1882L3.34566 15.0807L1.3916 15.9999L3.34566 16.919L2.3051 18.8114L4.4271 18.4056L4.69579 20.5491L6.17379 18.9726L7.65179 20.5491L7.92066 18.4056L10.0424 18.8115L9.00191 16.9191L10.956 15.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26735 6.26074L4.9176 7.16968L5.98292 6.83224L5.31929 7.73149L5.96954 8.64043L4.90917 8.28724L4.2456 9.18643L4.25392 8.06893L3.1936 7.71568L4.2591 7.37824L4.26735 6.26074Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26735 22.8132L4.9176 23.7222L5.98292 23.3847L5.31929 24.284L5.96954 25.1929L4.90917 24.8397L4.2456 25.7389L4.25392 24.6214L3.1936 24.2682L4.2591 23.9307L4.26735 22.8132Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5419 14.5371L12.8917 15.446L11.8264 15.1085L12.49 16.0078L11.8397 16.9168L12.9001 16.5635L13.5637 17.4627L13.5554 16.3453L14.6157 15.992L13.5502 15.6546L13.5419 14.5371Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPhilippines);
export default __webpack_public_path__ + "static/media/flag_philippines.f64e219a7ee63434c9d084c5219dc89e.svg";
export { ForwardRef as ReactComponent };